<template>
  <div class="auth auth--bg">
    <ul class="auth__menu auth__menu--color">
      <li class="auth__item">
        <img
          alt="Ingresa"
          src="https://secure-cdn.cumplo.cl/assets/cumplo2017/ingresa-icon-1a87015a52235cb7d884a1ff4030f21c.svg">
        <span class="auth__name--ml"><b>{{ userName }}</b></span>
        <br>
        <span
          class="auth__session--m auth__session--text aut">
            Última sesión: {{ lastLogin | formatDate }}
        </span>
        <ul class="user__menu">
          <li class="user__item">
            <router-link
              :to="{name: 'DashboardInvestment'}"
              class="user__link user__link--color"
              :class="this.$route.path === '/dashboard/inversiones' ?
                'user__link--active' : ''">
              <span>Panel de inversiones</span>
            </router-link>
          </li>
          <li class="user__item">
            <router-link
              :to="{name: 'DashboardVirtualAccount'}"
              class="user__link user__link--color"
              :class="this.$route.path === '/dashboard/cuenta-virtual' ?
                'user__link--active' : ''">
              <span>Cuenta virtual</span>
            </router-link>
          </li>
          <li class="user__item">
            <router-link
              :to="{name: 'InvestorClabe'}"
              class="user__link user__link--color"
              :class="this.$route.path === '/dashboard/clabe' ?
                'user__link user__link--active' : ''">
              <span>Mis clabes</span>
            </router-link>
          </li>
          <li class="user__item item__signout--mt">
            <span @click="signOut">Cerrar sesión</span>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'LoggedDesktop',
  filters: {
    formatDate: function (value) {
      const date = new Date(value)
      const hours = date.getHours()
      const minutes = (date.getMinutes() < '10' ? '0' : '') + date.getMinutes()
      var strTime = hours + ':' + minutes
      return (
        date.getDate() +
        '-' + ('0' + (date.getMonth() + 1)).slice(-2) +
        '-' + date.getFullYear() + ' ' +
        strTime
      )
    }
  },
  props: {
    userName: {
      type: String
    },
    lastLogin: {
      type: String
    }
  },
  methods: {
    signOut: function () {
      this.$store.dispatch('signout')
      this.$router.push({ name: 'UserProfile' })
    }
  }
}
</script>

<style lang="scss" scoped>
  @media (min-width: 1024px) {

  .auth__menu {
    list-style-type: none;
    padding: 0;
    margin: 1.5em;
    display: flex;
  }

  .auth__menu--color {
    color: $white;
  }

  .auth__item {
    cursor: pointer;
  }

  .auth__item::before {
    content: '';
  }

  .auth__name--ml {
    margin-left: .5em;
  }

  .auth__session--m {
    margin-left: 2.5em;
    margin-top: 0;
    display: block;
  }

  .auth__session--text {
    font-size: .7em;
  }

  .auth--bg {
    background: $midnight-blue;
  }

  .auth__item:hover .user__menu {
    display: block;
  }

  .user__menu {
    display: none;
    position: absolute;
    margin-top: 0;
    transition: all 0.5s ease;
    background: $midnight-blue;
    padding: 1em;
    border-radius: 0 0 .5em .5em;
    color: $white;
    width: 223px;
    right: 0;
  }

  .user__item {
    margin: 1em 0;
  }

  .user__item:hover {
    font-weight: bold;
  }

  .user__link--active {
    font-weight: bold;
  }

  .user__item:hover::before,
  .user__link--active::before {
    content: '';
    width: 4%;
    height: 20px;
    position: absolute;
    left: 0;
    background: $green;
  }

  .user__link--color {
    color: $white;
  }

  .user__item::before {
    content: '';
  }

  .item__signout--mt {
    margin-top: 2em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Navigation/Menu/Desktop/LoggedDesktop.vue